import React, { useState, useEffect } from "react";
import { useDispatch, useStore } from "react-redux";
import { ChatWidgetLayout } from "../ChatWidgetLayout";
import ACTIONS from "../../../store/action";

const FloatingChatView = ({ onNewChatTrigger, onStreamingStateChange }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const state = store.getState();
  const { activeConversationId, conversationHistory, shouldLoadHistory } = state.floatingChat;
  let selectedConversationId = activeConversationId;

  const [clearChatHistory, setClearChatHistory] = useState(false);

  const handleAfterConversationCreated = (conversationId) => {
    dispatch(ACTIONS.setFloatingChatConversationId(conversationId));
    selectedConversationId = conversationId;
  };

  const handleChatCleared = () => {
    setClearChatHistory(false);
  };

  const handleNewChat = () => {
    setClearChatHistory(true);
    dispatch(ACTIONS.setFloatingChatConversationId(null));
  };

  useEffect(() => {
    if (onNewChatTrigger) {
      handleNewChat();
    }
  }, [onNewChatTrigger]);

  const handleAfterLoadingSelectedConversation = (messages = []) => {
    if (activeConversationId && messages.length > 0) {
      dispatch(ACTIONS.setFloatingChatHistory(activeConversationId, messages));
    }

    if (shouldLoadHistory) {
      dispatch(ACTIONS.setFloatingChatShouldLoadHistory(false));
    }
  };

  return (
    <ChatWidgetLayout
      selectedConversationId={selectedConversationId}
      collapsed={false}
      shouldLoadHistory={shouldLoadHistory}
      clearChatHistory={clearChatHistory}
      handleAfterConversationCreated={handleAfterConversationCreated}
      handleAfterLoadingSelectedConversation={handleAfterLoadingSelectedConversation}
      onChatCleared={handleChatCleared}
      isFloatingMode={true}
      cachedHistory={shouldLoadHistory ? null : activeConversationId ? conversationHistory[activeConversationId] : null}
      onStreamingStateChange={onStreamingStateChange}
    />
  );
};

export { FloatingChatView };
